import { ref } from 'vue';

export function createMicrophoneMuteState(getMicrophoneStream) {
  const isMuted = ref(false);

  function setMuted(muted) {
    isMuted.value = Boolean(muted);
    const stream = getMicrophoneStream?.();
    stream?.getAudioTracks().forEach((track) => {
      track.enabled = !isMuted.value;
    });
  }

  function toggleMute() {
    setMuted(!isMuted.value);
  }

  return {
    isMuted,
    setMuted,
    toggleMute,
  };
}
